import { useMemo } from "react";
import { isAnyOf } from "../../../supporting";

const useAppTester = () => {
  return useMemo(() => isAnyOf(), [])
}

export default useAppTester;import { useMemo } from "react";
import { isAnyOf } from "../../../supporting";

const useAppTester = () => {
  return useMemo(() => isAnyOf(), [])
}

export default useAppTester;